export default {
  en: {
    checkListItemCard: {
      done: 'Done',
    },
    checklist: {
      button: 'Begin',
    },
    bookDemo: {
      title: 'Ready to connect to the rest of your suppliers?',
      text: 'Book a demo to learn more about how Risk Ledger can help you manage your third party risk',
      button: 'Book a demo',
    },
    trialGettingStarted: {
      hero: {
        welcome: 'Welcome, {firstName}!',
        trialMode: 'Trial mode',
        text: `Risk Ledger is an all-in-one solution to managing your third party risk management processes.
Let's take you through connecting and evaluating an example supplier`,
        link: 'Learn more about the platform',
      },
      checklist: {
        title: 'Getting started',
        subtitle: 'Up and running in 5 minutes',
        progress: '{completed}/{total} Completed',
        stepOne: {
          title: 'Start a trial',
          text: 'Start your trial to connect with Risk Ledger Managed Profiles, review real supplier data, and understand your risk straight away.',
          intro:
            "You've seen Risk Ledger from the supplier side, now experience it from your client's perspective. In this trial, you'll explore how your organisation can discover, assess, and understand supplier risk across your network.",
          listIntro: "In this trial, you'll:",
          bullets: {
            connect: 'Connect with a Risk Ledger Managed supplier and explore their profile',
            compliance: 'See how compliance scores are calculated',
            risks: 'Understand where risks and gaps exist',
            impact: "Learn how changes impact a supplier's risk posture",
          },
        },
        stepTwo: {
          title: 'Connect with Risk Ledger Managed suppliers',
          text: 'During your trial, you can connect instantly with pre-assessed Managed Profiles (e.g. AWS, Google Cloud, Microsoft) to explore supplier data and workflows.',
        },
        stepThree: {
          title: "Understand your suppliers' risk posture",
          text: 'Explore their controls and compliance to quickly understand risks and decide if they meet your requirements.',
        },
        stepFour: {
          title: 'Explore your supply chain network',
          text: 'Visualise your connected suppliers and the wider network beyond them to spot concentration risks across your supply chain.',
        },
        begin: 'Begin',
        watchVideo: 'Watch the video to see how it works, then start the task',
      },
      overviewBanner: {
        title: "Understand your suppliers' risk posture",
        text: "Watch how to assess your supplier's profile, understand their risk, and start identifying key areas to focus on.",
        thumbnailAlt: 'Help video thumbnail',
      },
      coachmark: {
        title: 'Search for a supplier',
        body: 'During your trial, you can only connect to Risk Ledger Managed suppliers and can connect up to five.',
      },
      viewSuppliersCoachmark: {
        title: 'View connected suppliers',
        body: "Click here to see suppliers you're connected to, then select them to assess their risk posture",
      },
      networkVizCoachmark: {
        title: 'Explore your network',
        body: 'Open the network visualisation here, then select a supplier node to explore your supply chain.',
      },
    },
    supplierCoverage: {
      step: {
        title: 'Check which suppliers are on Risk Ledger',
        descriptionIncomplete:
          "Upload your supplier list and we'll check how many are already on Risk Ledger.",
        descriptionComplete:
          "Upload a list of your key suppliers and we'll analyse how many are already on Risk Ledger.",
        button: 'Upload suppliers',
      },
      drawer: {
        title: 'Check which suppliers are on Risk Ledger',
        intro:
          "Upload a list of your suppliers and we'll review how many are already on Risk Ledger. We'll then share the results with you shortly.",
        uploadCard: {
          title: 'Upload supplier list',
          subtitle: 'Upload a CSV, Excel, PDF, or Word file',
          help: "Include your suppliers' names so we can match them against organisations on Risk Ledger",
          chooseFile: 'Choose file',
          empty: 'No supplier list uploaded yet',
        },
        validation: {
          title: 'No files uploaded',
          body: 'Upload a file and try again',
        },
        cancel: 'Cancel',
        submit: 'Send list',
        submitError: "Couldn't send supplier list. Try again",
      },
      removeFile: {
        title: 'Remove file',
        description: 'Are you sure you want to remove this file?',
        confirm: 'Remove',
        cancel: 'Cancel',
      },
      success: {
        title: 'Supplier list received',
        body1: 'Our team will review your supplier list and prepare your gap analysis.',
        body2: "You'll receive the results by email once it's ready.",
        button: 'Done',
      },
    },
  },
};
